import { erpApi } from "@/shared/axios";
import { useMutation } from "@tanstack/react-query";
import { urlBackendSoftnet } from '@/shared/constants/networking.constants';

const { post } = erpApi();

/**
 * Hook mutation para obtener reporte de contratos pendientes
 */
export const useObtenerReporteClientesValoresSoftnetSinPagos = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${urlBackendSoftnet}/api/clientes-sin-pagos`,
        params,
        true
      );
      return resp;
    },
  });
};

export const useObtenerReporteClientesValoresSoftnetPagoProporcionalSinMensualidad = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${urlBackendSoftnet}/api/clientes-proporcional-sin-mensualidad`,
        params,
        true
      );
      return resp;
    },
  });
};

export const useObtenerReporteClientesValoresSoftnetPagoProporcionalMensualidad = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${urlBackendSoftnet}/api/clientes-proporcional-mensualidad`,
        params,
        true
      );
      return resp;
    },
  });
};

export const useObtenerReporteClientesValoresSoftnetClientesCancelados = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${urlBackendSoftnet}/api/clientes-cancelados`,
        params,
        true
      );
      return resp;
    },
  });
};

export const useObtenerResumenClientesValoresSoftnetClientesRetirados = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${urlBackendSoftnet}/api/resumen-clientes-retirados`,
        params,
        true
      );
      return resp;
    },
  });
};
